
<p-panel>
  <app-reactive-form-builder
      #formbuilder
      (formChanges)="formChanges($event[0], $event[1])"
      (goBack)="goBack()"
      (afterSend)="afterSend($event)"
      [form]="form.formFields"
      [serverUrl]="''"
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [dropdownsFinalized]="dropdownsFinalized"
      [id]="getModel().id"
      [request]="this.getType() === 1 ? this.camposApi.campos.PUT : this.camposApi.campos.POST"
      [getRequest]="this.camposApi.campos.GET">
  </app-reactive-form-builder>
</p-panel>

<p-dialog [header]="'Mapa ' + env.parcelaName" [(visible)]="form.mapaAbierto" #mapaDialog (onShow)="scrollToTop()">                     
  <div *ngIf="form.mapaAbierto" style="height:86%; margin-left:20px; margin-right:20px; width: 80vw !important; top: 0">
    <app-mapa-add
        [origin]="form.origin"
        [finca]="form.finca"
        [localidad]="form.localidad"
        [cultivo]="form.cultivo"
        [variedad]="form.variedad"
        [parcelaNombre]="form.parcelaNombre"
        (fromMapa)="getFromMapa($event)">
    </app-mapa-add>
  </div>
</p-dialog>

<p-dialog header="Añadir cultivos / variedades" [(visible)]="form.openDialog" (onShow)="scrollToTop()">
      <app-reactive-form-builder
        #cultivosFormBuilder
        (formChanges)="formChangesCultivos($event[0], $event[1])"
        (goBack)="goBack()"
        (afterSend)="afterSendCultivo($event)"
        [form]="form.formFieldsCultivos"
        [serverUrl]="''"
        [dropdownLoadTrigger]="dropdownLoadTrigger"
        [id]="modelCultivo.id ?? ''"
        [request]="this.visitasVariedadMesApi.visitasVariedadMes.POST"
        [getRequest]="this.visitasVariedadMesApi.visitasVariedadMes.GET">
      </app-reactive-form-builder>
</p-dialog>
